
import { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { config } from '../../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import axios from 'axios';
function MiscellaneousCitizenView({ miscellaneousno }) {
    const [getReciptData, setReciptData] = useState([]);
    const miscellNo = miscellaneousno;
    const fetchDetails = async () => {
        try {

            const response = await axios.get(config.url.API_URL + `citizen-service/miscellaneousownerdata/${miscellNo}`)
            if (response?.data?.scode === "01") {
                setReciptData(response?.data?.data[0]);


            } else if (response?.data?.scode === "02") {
                Swal.fire({
                    title: "No Data Found",
                    icon: "question",
                });
            } else if (response?.data?.scode === "03") {
                Swal.fire({
                    title: "An error occurred while fetching data",
                    icon: "question",
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if (miscellNo) {
            fetchDetails();
        }
    }, []);



    return (
        <div>
            <style>{printStyles}</style>
            <Container className="p-3">

                <Row>
                    <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='empty-col'>
                    </Col>

                    <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8} className='mid-col'>


                        <div id="print-area" className='receipt p-4'>
                            <Row
                                className="mb-2">
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <img
                                        src="../../img/logo_official-pr.png"
                                        alt="Logo" className="img-fluid"
                                    />        </Col>
                                <Col xs={8} sm={8} md={8} lg={8} xl={8} xxl={8}
                                    className="text-center receipt-head">

                                    <h5 style={{ margin: 0, padding: 0 }}>Panchayat Raj and Rural Development</h5>

                                    <h6
                                        style={{ margin: 0, padding: 0 }}>
                                        {getReciptData.secretariat_desc}{" "}
                                        Gram Panchayat <br />
                                        {getReciptData.mandal_desc} Mandal, {getReciptData.district_desc} District <br />
                                        {getReciptData.financial_year} {" "}
                                        Financial Year <br />
                                        <br></br>
                                    </h6>    <h5><span style={{ color: "blue" }}>Miscellaneous Acknowledgement</span></h5>    </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <img
                                        src="../../img/pr.jpg"
                                        alt="Logo" className="img-fluid"
                                    /></Col>
                            </Row>

                            <div
                                className='receipt-top p-2'>
                                <div>
                                    <Row>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>Miscellaneous Reference Number :</p></Col>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>{getReciptData.miscellaneous_reference_no || "NA"}</p></Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>Applicant Name :</p></Col>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>{getReciptData.owner_name || "NA"}</p></Col>
                                    </Row>


                                    <Row>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>Mobile Number :</p></Col>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>{getReciptData.mobile_no || "NA"}</p></Col>
                                    </Row>


                                    <Row>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>Category :</p></Col>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>{getReciptData.category_desc || "NA"}</p></Col>
                                    </Row>



                                    <Row>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}> Miscellaneous Purpose Category :</p></Col>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>{getReciptData.purposecategory_desc || "NA"}</p></Col>
                                    </Row>

                                    <Row>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>Due Amount :</p></Col>
                                        <Col xs={6}><p
                                            style={{ margin: 0 }}>{getReciptData.demand_amount || "NA"}</p></Col>
                                    </Row>
                                </div>

                                <Row className="no-print mt-3">
                                    <Col xs={12}
                                        className="text-end">
                                        <button
                                            className="btn btn-primary me-2 mb-2"
                                            onClick={() => window.print()}
                                        >
                                            Print
                                        </button>

                                    </Col>
                                </Row>


                            </div>

                        </div>
                    </Col>

                </Row>


            </Container>

        </div>
    )
}


const printStyles = `
 @media print {

  @page {
    size: A4;
    margin: 0;
  }

  
  html, body {
    width: 210mm;
    height: 297mm;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  body * {
    visibility: hidden;
  }
  #print-area, #print-area * {
    visibility: visible !important;
  }
  #print-area {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
  }
  .receipt-head h5:nth-of-type(2) {
    color: blue !important;
  }
}  

`;




export default MiscellaneousCitizenView